import {emptyParametersByType} from '../components/ruleset/TargetTypeSelector'
import {INCLUDE_ALL_PATTERN} from '@github-ui/repos-rules-types/rules-types'
import type {
  Condition,
  ConditionParameters,
  IncludeExcludeParameters,
  TargetObjectType,
  TargetType,
  TargetWithParameters,
} from '@github-ui/repos-rules-types/rules-types'

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every(item => typeof item === 'string')

export function parseIncludeExcludeParameters(parameters: unknown): IncludeExcludeParameters | undefined {
  if (typeof parameters !== 'object' || parameters === null) {
    return undefined
  }

  const {include, exclude} = parameters as Record<string, unknown>
  if (!isStringArray(include) || !isStringArray(exclude)) {
    return undefined
  }

  return {include, exclude}
}

export function isAllCondition(targetType: TargetType, parameters: ConditionParameters) {
  const params = parameters as IncludeExcludeParameters
  return (
    (targetType === 'repository_name' || targetType === 'organization_name') &&
    params.include.length === 1 &&
    params.include[0] === INCLUDE_ALL_PATTERN &&
    params.exclude.length === 0
  )
}

export function getTargetMode(condition: Condition) {
  return isAllCondition(condition.target, condition.parameters) ? 'all_repos' : condition.target
}

export function getDefaultTargetByObject(
  objectType: TargetObjectType,
  options?: {
    supportedConditionTargetObjects?: TargetObjectType[]
  },
): TargetWithParameters {
  if (objectType === 'repository' && options?.supportedConditionTargetObjects?.includes('organization')) {
    return {
      type: 'repository_name',
      parameters: emptyParametersByType('all_repos'),
    }
  }

  const objectMap: Record<TargetObjectType, TargetType> = {
    organization: 'organization_name',
    repository: 'repository_property',
    ref: 'ref_name',
    workflow: 'workflow_path',
  }
  const targetType = objectMap[objectType]
  if (!targetType) {
    throw new Error(`Unknown target object type: ${objectType}`)
  }

  return {
    type: targetType,
    parameters: emptyParametersByType(targetType),
  }
}
